import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAppContext } from "../../../context/AppContext";
import ApiService from "../../../services/ApiService";
import Sidebar from "../../../components/Sidebar";
import Toast from "../../../components/Toast";
import SectionLoader from "../../../components/SectionLoader";
import BackButton from "../../../components/BackButton";
import Swal from "sweetalert2";

const Jobsite: React.FC = () => {
  const navigate = useNavigate();
  const deliveryID = localStorage.getItem("delivery_id");
  const { salesOrder, purchaseOrder, delivery, setDelivery, attachments } = useAppContext();

  const [buttonLoading, setButtonLoading] = useState<boolean>(false);
  const [toast, setToast] = useState<{
    message: string;
    type: "success" | "error";
  } | null>(null);

  if (!purchaseOrder && !salesOrder) return <SectionLoader />;
  const shippingAddress = salesOrder?.so_data?.shipping_address;
  // const ContactFullName = purchaseOrder?.po_data?.delivery_address?.phone;

  const fullAddress = `${shippingAddress.address}, ${shippingAddress.city}, ${shippingAddress.zip} `;

  // const mapUrl = `https://www.google.com/maps?q=${encodeURIComponent(
  //   fullAddress
  // )}`;

  // const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

  // const handleOpenMap = () => {
  //   const encoded = encodeURIComponent(fullAddress);

  //   if (isMobile) {
  //     window.location.href = `geo:0,0?q=${encoded}`;
  //   } else {
  //     window.open(`https://www.google.com/maps?q=${encoded}`, "_blank");
  //   }
  // };

  // const handleOpenMap = () => {
  //   const encoded = encodeURIComponent(fullAddress);
  //   const ua = navigator.userAgent;

  //   if (/Android/i.test(ua)) {
  //     window.location.href = `geo:0,0?q=${encoded}`;
  //   } else if (/iPhone|iPad|iPod/i.test(ua)) {
  //     window.location.href = `http://maps.apple.com/?q=${encoded}`;
  //   } else {
  //     window.open(`https://www.google.com/maps?q=${encoded}`, "_blank");
  //   }

  //    const fallback = setTimeout(() => {
  //        window.open(`https://www.google.com/maps?q=${encoded}`, "_blank");
  //     }, 1000);

  //    window.addEventListener("pagehide", () => clearTimeout(fallback));
  // };

  const handleOpenMap = () => {
    const encoded = encodeURIComponent(fullAddress);
    const ua = navigator.userAgent;

    // On iPhone/iPad, show options to choose map app
    if (/iPhone|iPad|iPod/i.test(ua)) {
      Swal.fire({
        title: "Choose Map App",
        text: "Select which map application you'd like to use",
        showCancelButton: true,
        showDenyButton: true,
        confirmButtonText: "Google Maps",
        denyButtonText: "Apple Maps",
        cancelButtonText: "Cancel",
        confirmButtonColor: "#4285F4",
        denyButtonColor: "#007AFF",
        cancelButtonColor: "#6c757d",
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          // Google Maps - use location.href to avoid blank tab
          window.location.href = `https://www.google.com/maps?q=${encoded}`;
        } else if (result.isDenied) {
          // Apple Maps
          window.location.href = `http://maps.apple.com/?q=${encoded}`;
        }
      });
    } else if (/Android/i.test(ua)) {
      // Android - geo: URL shows app picker
      const mapUrl = `geo:0,0?q=${encoded}`;
      window.location.href = mapUrl;
      
      // Fallback to Google Maps in browser if geo: doesn't work
      const fallback = setTimeout(() => {
        window.open(`https://www.google.com/maps?q=${encoded}`, "_blank");
      }, 1000);
      window.addEventListener("pagehide", () => clearTimeout(fallback));
    } else {
      // Desktop - open Google Maps in new tab
      window.open(`https://www.google.com/maps?q=${encoded}`, "_blank");
    }
  };

  const CustomerInfo = {
    customerName: salesOrder?.customer_name || "N/A",
    // deliveryNotes: salesOrder?.special_instructions || "",
    contactPerson: salesOrder?.so_data?.custom_fields?.filter(
      (field: any) => field.placeholder === "cf_jobsite_contact_person"
    )[0]?.value,
    Address: (
      <ul>
        <li>
          <strong>Address: </strong> {shippingAddress?.address}
        </li>
        <li>
          <strong>City: </strong> {shippingAddress?.city}
        </li>
        <li>
          <strong>State: </strong> {shippingAddress?.state}
        </li>
        <li>
          <strong>Zip: </strong> {shippingAddress?.zip}
        </li>
      </ul>
    ),
  };

  const contact = CustomerInfo.contactPerson || "";
  const pieces = contact.trim().split(" ");
  
  let phoneStartIndex = -1;
  for (let i = 0; i < pieces.length; i++) {
    if (pieces[i].includes("(") || /\d/.test(pieces[i])) {
      phoneStartIndex = i;
      break;
    }
  }
  
  const display = phoneStartIndex > 0 ? pieces.slice(0, phoneStartIndex).join(" ") : "";
  const phoneRaw = phoneStartIndex >= 0 ? pieces.slice(phoneStartIndex).join(" ") : "";

  const cleanPhone = phoneRaw.replace(/[^\d+]/g, "");
  
  const formatPhone = (phone: string) => {
    const cleaned = phone.replace(/[^\d+]/g, "");
    if (cleaned.length === 10) {
      return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
    }
    return phone;
  };

  const formattedPhone = formatPhone(phoneRaw);

  const ReachedDestinaton = async () => {
    setButtonLoading(true);

    // Use delivery from context, or fallback to localStorage
    const currentDeliveryId = delivery?.id || deliveryID;
    console.log("delivery?.status", delivery?.status);
    if (delivery && delivery?.status !== "picked_up") {
      navigate("/proof-of-dump-meterial");
      return;
    }

    if (!currentDeliveryId) {
      setToast({
        message: "Delivery ID not found. Please refresh the page.",
        type: "error",
      });
      setButtonLoading(false);
      return;
    }

    const vendor_id = localStorage.getItem("vendor_id");
    let responseData = null;
    try {
      responseData = await ApiService.ReachedDestination({
        delivery_id: currentDeliveryId,
        vendor_id: vendor_id || null,
      });

      if (responseData && responseData.success) {
        setToast({
          message:
            responseData.message ||
            "Status Updated, please proceed to the next step",
          type: "success",
        });
        setDelivery(responseData.data);
        setTimeout(() => {
          localStorage.setItem("page", "proof-of-dump-meterial");
          navigate("/proof-of-dump-meterial");
        }, 500);
      } else {
        setToast({ message: responseData.message, type: "error" });
        setButtonLoading(false);
      }
    } catch (error: any) {
      setToast({
        message: error.message || "Cannot update, Server Error",
        type: "error",
      });
      setButtonLoading(false);
    }
  };

  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <Sidebar />

          <div className="col-lg-9 col-12 content-area p-md-3 p-0">
            <div className="row m-auto">
              <div className="col-12 mb-1 mt-2">
                <BackButton />
              </div>
              <div className="col-md-12 mb-1">
                <h3 className="fw-bold">Jobsite Information</h3>
              </div>
              <div className="col-md-12 mb-1">
                <div className="h-100 card-dark px-lg-5 px-2 py-2">
                  <p className="mb-3">
                    <strong className="secondary-text">Customer Name: </strong>{" "}
                    {CustomerInfo.customerName}
                  </p>
                  <div className="mb-3">
                    <strong className="secondary-text">Address: </strong>
                    {CustomerInfo.Address}
                  </div>
                  <p className="mb-3">
                    <strong className="secondary-text">Contact: </strong>
                    {display && <span>{display} </span>}
                    <a className="secondary-text" href={`tel:${cleanPhone}`} style={{ whiteSpace: 'nowrap', display: 'inline-block' }}>
                      <i className="bi bi-telephone-fill secondary-text me-1"></i>
                      <span style={{ userSelect: 'text' }}>{formattedPhone}</span>
                    </a>
                  </p>
                </div>
              </div>

              {salesOrder?.special_instructions && (
                <div className="col-md-12">
                  <h4 className="mb-2 mt-3 fw-semibold headings">Additional delivery notes for drivers</h4>
                  <div className="card-light text-center py-4 px-lg-5 mb-3">
                    <h6>
                      {salesOrder?.special_instructions}
                    </h6>
                  </div>
                </div>
              )}

              {Array.isArray(attachments) && attachments.length > 0 && (
                <div className="col-md-12 mb-2">
                  <div
                    className="card-dark d-block"
                    style={{
                      padding: '5px',
                      borderRadius: '16px',
                      background: 'linear-gradient(135deg, #1D3340 0%, #2a4758 100%)',
                    }}
                  >
                    <div className="d-flex align-items-center gap-2 mb-4">
                      <div
                        style={{
                          width: '32px',
                          height: '32px',
                          borderRadius: '8px',
                          background: 'rgba(224, 123, 0, 0.15)',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                        }}
                      >
                        <i className="bi bi-paperclip" style={{ fontSize: '16px', color: '#E07B00' }}></i>
                      </div>
                      <h6
                        className="mb-0 fw-semibold"
                        style={{
                          color: '#fff',
                          fontSize: '16px',
                          letterSpacing: '-0.2px',
                        }}
                      >
                        Jobsite Maps & Attachments
                      </h6>
                      <div
                        style={{
                          marginLeft: 'auto',
                          padding: '4px 10px',
                          borderRadius: '12px',
                          background: 'rgba(255, 255, 255, 0.1)',
                          fontSize: '12px',
                          color: 'rgba(255, 255, 255, 0.9)',
                          fontWeight: '500',
                        }}
                      >
                        {attachments.length} {attachments.length === 1 ? 'file' : 'files'}
                      </div>
                    </div>

                    <div className="d-flex flex-column gap-2">
                      {attachments.map((attachment: any, index: number) => (
                        <Link
                          key={attachment.id || attachment.file_name || index}
                          to={attachment?.file_url}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ textDecoration: 'none', display: 'block' }}
                        >
                          <div
                            className="d-flex align-items-center gap-3"
                            style={{
                              backgroundColor: "#fff",
                              borderRadius: "12px",
                              border: '1px solid rgba(0, 0, 0, 0.06)',
                              transition: 'all 0.25s cubic-bezier(0.4, 0, 0.2, 1)',
                              cursor: 'pointer',
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.transform = 'translateY(-1px)';
                              e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.1)';
                              e.currentTarget.style.borderColor = 'rgba(224, 123, 0, 0.3)';
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.transform = 'translateY(0)';
                              e.currentTarget.style.boxShadow = 'none';
                              e.currentTarget.style.borderColor = 'rgba(0, 0, 0, 0.06)';
                            }}
                          >
                            <div
                              style={{
                                width: '40px',
                                height: '40px',
                                borderRadius: '10px',
                                background: 'linear-gradient(135deg, #fff5e6 0%, #ffe0b3 100%)',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                flexShrink: 0,
                              }}
                            >
                              <i className="bi bi-file-earmark-text" style={{ fontSize: '18px', color: '#E07B00' }}></i>
                            </div>
                            <div className="flex-grow-1" style={{ minWidth: 0, overflow: 'hidden' }}>
                              <div
                                style={{
                                  fontSize: '14px',
                                  color: '#1a1a1a',
                                  fontWeight: '500',
                                  lineHeight: '1.4',
                                  whiteSpace: 'nowrap',
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                  marginBottom: '2px',
                                }}
                                title={attachment?.file_name}
                              >
                                {attachment?.file_name}
                              </div>
                              <div style={{ fontSize: '11px', color: '#8b8b8b', fontWeight: '400', letterSpacing: '0.2px' }}>
                                Tap to open
                              </div>
                            </div>
                            <div
                              style={{
                                width: '36px',
                                height: '36px',
                                borderRadius: '8px',
                                background: '#f5f5f5',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                flexShrink: 0,
                              }}
                            >
                              <i className="bi bi-download" style={{ fontSize: '14px', color: '#666' }}></i>
                            </div>
                          </div>
                        </Link>
                      ))}
                    </div>
                  </div>
                </div>
              )}
            </div>

            <div className="d-flex row mt-4 m-auto flex-wrap align-items-center justify-content-center gap-3">
              <div className="col-md-6 col-12">
                <button
                  onClick={handleOpenMap}
                  className="btn-light-orange w-100"
                >
                  Jobsite Map
                </button>
              </div>
              <div className="col-md-6 col-12">
                <button
                  disabled={buttonLoading}
                  className="btn-orange w-100"
                  onClick={() => ReachedDestinaton()}
                >
                  {buttonLoading && (
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                  )}
                  Reached Destination
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {toast && (
        <Toast
          message={toast.message}
          type={toast.type}
          onClose={() => setToast(null)}
        />
      )}
    </>
  );
};

export default Jobsite;
